import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api/v1';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const emailService = {
  generateEmail: () => api.post('/generate-email'),
  getCurrentEmail: (sessionId) => api.get(`/email/current?sessionId=${sessionId}`),
  extendEmailTime: (sessionId) => api.post(`/email/extend?sessionId=${sessionId}`),
  getMessages: (email, sessionId, page = 0, size = 10) => api.get(`/emails/${email}`, {
      params: {
        page,
        size
      },
      headers: {
        'Session-ID': sessionId
      }
    })
};

export const paymentService = {
  createOrder: (amount) => api.post('/payment/create-order', null, {
    params: { amount }
  })
};

export default api; 